import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { URLS } from '../../../shared/constants/api-request.urls';

@Injectable({ providedIn: 'root' })
export class RatiosService {
  private http = inject(HttpClient);

  getRatios(stockId: string, filter?: string): Observable<any> {
    let params = new HttpParams();
    params = params.set('stockId', stockId);
    if (filter) {
      params = params.set('filter', filter);
    }
    return this.http.get(URLS.RATIO, { params });
  }

  getRatio(id: string): Observable<any> {
    return this.http.get(`${URLS.RATIO}/${id}?mode=edit`);
  }

  createRatio(ratio: any): Observable<any> {
    console.log('Creating ratio:', ratio);
    return this.http.post(URLS.RATIO, ratio);
  }

  updateRatio(id: string, ratio: any): Observable<any> {
    return this.http.put(`${URLS.RATIO}/${id}`, ratio);
  }

  deleteRatio(id: string): Observable<any> {
    return this.http.delete(`${URLS.RATIO}/${id}`);
  }
}
